export default function initHeaderScroll() {
  const menuItems = document.querySelectorAll('.header__item');
  const firstMenuItem = menuItems[0]; // первая ссылка
  const sections = {
    solutions: document.querySelector('.content-section.solutions'),
  };

  function removeActive() {
    menuItems.forEach(item => item.classList.remove('header__item-active'));
  }

  function setDefaultActive() {
    if (firstMenuItem) {
      firstMenuItem.classList.add('header__item-active');
    }
  }

  function onScroll() {
    const scrollPosition = window.scrollY + window.innerHeight / 2;

    let isInSection = false;

    Object.entries(sections).forEach(([key, section]) => {
      if (!section) return;
      const top = section.offsetTop;
      const height = section.offsetHeight;

      if (scrollPosition >= top && scrollPosition < top + height) {
        isInSection = true;
        removeActive();
        const activeLink = document.querySelector(`.header__menu a[href="#${key}"]`);
        if (activeLink) {
          activeLink.closest('.header__item').classList.add('header__item-active');
        }
      }
    });

    // Если мы не в указанном блоке — ставим активной первую ссылку
    if (!isInSection) {
      removeActive();
      setDefaultActive();
    }
  }

  window.addEventListener('scroll', onScroll);

  // Запускаем один раз при загрузке страницы
  onScroll();
}
